import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Stack from '@ms/yammer-web-core-ui/dist/components/Stack';
import React, { FC } from 'react';

import AppHeaderLogo from '../AppHeaderLogo';

const AppHeaderStatic: FC = () => (
  <Block paddingTop={1} textAlign="right" backgroundColor="bodyBackground">
    <Stack horizontal={true} verticalAlign="center" horizontalAlign="start">
      <AppHeaderLogo />
    </Stack>
  </Block>
);

export default AppHeaderStatic;
